const dataConstant = {
  APIStatus: {
    Success: "Success",
    Failure: "Failure",
  },
  dateFormatWithTime: "M/D/YYYY HH:mm",
  centralAmericaTimeZone: "America/Chicago",
  dateFormat: "YYYY-MM-DD",
  dateFormatUSFormat: "MM/DD/YYYY",
  passwordRegex:
    /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[@$!%*?&])[A-Za-z\d@$!%*?&]{6,16}$/,
  roles: {
    admin: "Admin",
    staff: "Staff",
    marketer: "Marketer",
  },
  ErnieSignImageUrl: "Signature_Images/Ernie_Sign.png",
};

export default dataConstant;
